import { Component, Input } from '@angular/core';

@Component({
    selector: 'weather-widget',
    standalone: true,
    templateUrl: './weatherWidget.component.html',
    styleUrls: ['./weatherWidget.component.scss']
})
export class WeatherWidgetComponent {
    @Input() data: any;

    constructor() { }
}
